import React from 'react'
import { Box, TextBody } from '@ally/metronome-ui'
import WarningIcon from './WarningIcon'
import { useHostServices } from '../HostServices'

interface NoticeProps {
  dataTestId?: string
  lob?: string
}

const StaleDataNotice: React.FC<NoticeProps> = ({
  dataTestId = 'stale-data-notice',
  lob,
}) => {
  const { featureFlags } = useHostServices()
  const isCCMigration = featureFlags.variation(
    'FF_credit-card-migration-message',
    false,
  )
  const showCCMigrationCopy = isCCMigration && lob === 'CC'

  return (
    <Box mb="sm" lineHeight={1.5} display="flex" data-testid={dataTestId}>
      <Box display="inline">
        <WarningIcon />
      </Box>
      <TextBody tag="p" size="sm">
        {showCCMigrationCopy
          ? 'We can’t show your account information right now. A fix is in the works. Check back later.'
          : 'We’ve hit a snag when trying to update your account information. A fix is in the works.'}
      </TextBody>
    </Box>
  )
}

export default StaleDataNotice
